import React, { useEffect } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react';
import '../../../../components/SplitActions/style.scss';
import { Typography, useTheme, Tab, Tabs, Box, IconButton, Stack, Accordion, AccordionSummary, DialogActions, Button } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import AddEditContacts from './AddEditContacts';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import { useTranslation } from 'react-i18next';

export default function ContactsDetails({ isDrawerOpen, toggleDrawer, contact, init, permission }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();

  const [contactDetails, setContactDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAddEditContacts, setOpenAddEditContacts] = useState(false);

  useEffect(() => {
    if (contact) {
      getContactDetails();
    } else {
      setContactDetails(null);
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [contact]);

  const getContactDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `contact-management/${contact?._id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setContactDetails(data.response);
      }
      setLoading(false);
    }
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-16px]">
        <IconButton
          disabled={!Boolean(contact)}
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {contactDetails?.length <= 0 && !loading && <NoDataFound />}
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <>
                <Stack flex={1}>
                  <Box
                    sx={{
                      display: 'flex',
                      borderBottom: 1,
                      border: 'none',
                      color: 'rgba(255, 255, 255, 1)',
                      borderRadius: '5px 5px 0px 0px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Stack
                      style={{ justifyContent: 'center' }}
                      className="px-[16px] !mt-[10px]"
                    >
                      <Typography
                        className="fw-medium ff-Roboto fs-16"
                        color={text}
                      >
                        {t('Details')}
                      </Typography>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                      >
                        <Typography
                          className="fw-medium ff-Roboto fs-10"
                          color={textLight}
                        >
                          {t('Last modified')}
                        </Typography>
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !ml-[6px]"
                          color={text}
                        >
                          {moment(contactDetails?.modifiedOn).format('DD-MMM-YYYY')}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>
                  <Stack
                    style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                    className="!my-[10px]"
                  />
                  <Stack
                    direction={'row'}
                    className="px-[16px] !mb-[16px]"
                  >
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Company name')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium capitalize"
                        color={text}
                        style={{ maxWidth: '225px' }}
                      >
                        {contactDetails?.companyName}
                      </Typography>
                    </Stack>
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular "
                        color={text}
                      >
                        {t('Company type')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium capitalize"
                        color={text}
                      >
                        {contactDetails?.companyType}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={'row'}
                    className="px-[16px] !mb-[16px]"
                  >
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Address')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium"
                        color={text}
                        style={{ maxWidth: '225px' }}
                      >
                        {contactDetails?.regAddress}
                      </Typography>
                    </Stack>
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular "
                        color={text}
                      >
                        {t('State/Province')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium capitalize"
                        color={text}
                      >
                        {contactDetails?.stateName}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={'row'}
                    className="px-[16px] !mb-[16px]"
                  >
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Country')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium capitalize"
                        color={text}
                      >
                        {contactDetails?.countryName}
                      </Typography>
                    </Stack>
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Zip Code')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium"
                        color={text}
                      >
                        {contactDetails?.zipCode}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                    className="!my-[16px] !mx-[16px] !mr-[16px]"
                  />
                  <Stack
                    direction={'row'}
                    // alignItems={'center'}
                    className="px-[16px]"
                  >
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Full name')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium !capitalize"
                        color={text}
                      >
                        {contactDetails?.name}
                      </Typography>
                    </Stack>
                    <Stack flex={0.5}>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={text}
                      >
                        {t('Email')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium"
                        color={text}
                      >
                        {contactDetails?.email}
                      </Typography>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular !mt-[16px]"
                        color={text}
                      >
                        {t('Phone')}
                      </Typography>
                      <Typography
                        className="fs-14 ff-Roboto fw-medium"
                        color={text}
                      >
                        {(contactDetails?.phoneCode || '') + '-' + (contactDetails?.phoneNumber || '')}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack flexGrow={1} />
                  <Stack alignItems={'flex-end'}>
                    {permission?.editAccess && <Button
                      sx={{
                        border: 1,
                        margin: '10px',
                        color: theme.palette.primary.text,
                        borderColor: '#14285A4D',
                        backgroundColor: '#FFFFFF',
                        '&:hover': {
                          borderColor: '#14285A4D',
                          backgroundColor: '#FFFFFF',
                          borderColor: '#14285A4D',
                        },
                      }}
                      style={buttonStyle2}
                      variant="contained"
                      // style={{ width: '128px', marginLeft: '80px', height: '40px', borderColor: '#14285A4D' }}
                      onClick={() => {
                        setOpenAddEditContacts(true);
                      }}
                    >
                      {t('Edit details')}
                    </Button>}
                  </Stack>
                </Stack>
              </>
            )}
          </>
        ) : null}
      </Stack>
      {openAddEditContacts && (
        <AddEditContacts
          contact={contactDetails}
          modelOpen={openAddEditContacts}
          onModelHandleClose={(event) => {
            if (event) {
              getContactDetails();
              init();
            }
            setOpenAddEditContacts(false);
          }}
          type={'edit'}
        />
      )}
    </Stack>
  );
}
